import InfoIcon from '@clearkit/icons/glyphs/InfoHollow';
import { CKTooltip } from 'clearkit';

export default function InfoTooltip({ title }) {
  return (
    <CKTooltip tooltip={title} placement="top">
      <div className="ml-2 text-gray-600 outline-none">
        <InfoIcon width="16" height="16" />
      </div>
    </CKTooltip>
  );
}

InfoTooltip.propTypes = {
  title: PropTypes.string.isRequired,
};
